import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '../models/features.enum';
import { Injectable } from '@angular/core';

@Injectable()
export class DisableEmailReceivingPersonPrefillFeature implements IFlagFeature {
  name: string = Features.DISABLE_EMAIL_RECEIVING_PERSON_PREFILL;

  public isEnabled(container?: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
